import { render } from "./AddRecordedVideosModal.vue?vue&type=template&id=457caf8d"
import script from "./AddRecordedVideosModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddRecordedVideosModal.vue?vue&type=script&setup=true&lang=js"

import "./AddRecordedVideosModal.vue?vue&type=style&index=0&id=457caf8d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/AddRecordedVideosModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "457caf8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('457caf8d', __exports__)) {
    api.reload('457caf8d', __exports__)
  }
  
  module.hot.accept("./AddRecordedVideosModal.vue?vue&type=template&id=457caf8d", () => {
    api.rerender('457caf8d', render)
  })

}


export default __exports__